module.exports = __webpack_public_path__ + "img/img-widget-custom-poll.7b41a6b5.svg";